/**
 * The two palettes the chrome hands out when something new needs a colour.
 *
 * They differ on purpose. A **source** may take the brass, because the manual
 * source already has it and a feed is the same kind of thing; a **circle** may
 * not, because brass is what the ring itself is drawn in and a circle painted
 * brass would vanish into it. Both are distinct at a glance on night.
 */

export const CIRCLE_COLOURS: readonly string[] = [
  '#c98f4b',
  '#7fce9b',
  '#6aa9d8',
  '#c98bd0',
  '#d1685f',
  '#8494a6',
];

export const SOURCE_COLOURS: readonly string[] = [
  '#d8b26a',
  '#6aa9d8',
  '#7fce9b',
  '#c98bd0',
  '#d1685f',
  '#8b8f9a',
];

/**
 * The first colour in `palette` nobody is using yet, or the first colour at
 * all once they are all taken. Case-insensitive, and an absent colour — a
 * circle that inherits — takes nothing off the table.
 */
export function nextColour(
  palette: readonly string[],
  used: Iterable<string | null | undefined>,
): string {
  const taken = new Set<string>();
  for (const colour of used) if (colour) taken.add(colour.toLowerCase());
  return palette.find((c) => !taken.has(c.toLowerCase())) ?? palette[0]!;
}
